/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component} from '@angular/core';

import {ModalService} from './modal.service';

/**
 * Component that displays a backdrop when at least one modal is currently open.
 */
@Component({
  selector: 'gp-modal-backdrop',
  template: '<div *ngIf="openModals.length > 0" class="modal-backdrop in"></div>'
})
export class ModalBackdropComponent {

  public openModals: Array<string> = [];

  constructor(modalService: ModalService) {
    modalService.modalOpened.subscribe(id => this.openModals.push(id));
    modalService.modalClosed.subscribe(id => {
      if (id !== undefined) {
        const firstIndex = this.openModals.findIndex(modal => modal === id);
        if (firstIndex !== -1) {
          this.openModals.splice(firstIndex, 1);
        }
      } else {
        this.openModals.pop();
      }
    });
  }
}
